export const propertyPage = {
  id: 'property-center-properties-detail',
  name: _TL_('Property'),
  route: 'propertycenter/property',
  searchable: false,
};
